import { MetadataError } from './MetadataError'

export class BoundsError extends MetadataError {}

export class BadArgumentsError extends MetadataError {}

export class AssertionError extends MetadataError {}

export class TimeoutError extends MetadataError {}
